module.exports = __webpack_public_path__ + "static/smart-sm-e966bd73d397ba8857fe65ca61f3a7ab.jpg";